import api from '../../api'
import { buildTranscriptSearchParams, TranscriptFilters, TranscriptSearchResponse } from './transcriptsModel'

export const transcriptsEndpoint = '/web/admin/media-captures'

export const searchMediaCaptures = async (filters: TranscriptFilters): Promise<TranscriptSearchResponse> => {
  return (await api.get(transcriptsEndpoint, { params: buildTranscriptSearchParams(filters) })).data
}

export const getAudioLink = async (id: string, tenantId: number): Promise<string> => {
  return (await api.get(`${transcriptsEndpoint}/${id}/audio-link`, { params: { tenantId } })).data.link
}

export const retryTranscription = async (id: string, tenantId: number): Promise<void> => {
  await api.post(`${transcriptsEndpoint}/${id}/retry-transcription`, null, { params: { tenantId } })
}
